<template>
  <div class="lottery-winner-dialog" v-if="dialogVisible">
    <div class="lottery-winner-list">
      <lottery-title
        :title="$t('interact_tools.interact_tools_1020')"
        @closeWinner="dialogVisible = false"
      />
      <div class="lottery-winner-wrapper" v-loading="loading">
        <template v-if="loading">
          <div class="winner-content">
            <div class="no-winner"></div>
          </div>
        </template>
        <template v-else>
          <div class="winner-people" v-if="total">
            {{ $t('host.k_567001') }}
            <span>{{ total }}</span>
            {{ $t('host.k_567002') }}
          </div>
          <vh-button
            v-if="total && isLeleEmbedMode"
            type="text"
            round
            class="btn-export"
            @click="handleExport(lotteryId)"
          >
            {{ $t('common.common_1048') }}
          </vh-button>
          <div class="winner-content">
            <div v-if="!winnerList.length" class="no-winner">
              <div class="no-win-lottery-img">
                <img src="../../img/no-winner.png" alt="" />
              </div>
              <p class="tip">{{ $t('host.k_567003') }}</p>
            </div>
            <vh-scrollbar style="height: 100%" v-loadMore="loadMoreData" v-else>
              <ul class="lottery-winner-wrap">
                <li class="lottery-user" v-for="(item, index) in winnerList" :key="index">
                  <span class="serial">{{ index | fmtSerial }}</span>
                  <img class="avatar" :src="item.user_avatar || defaultAvatar" alt />
                  <p class="nickname">{{ item.user_name }}</p>
                  <span class="prize">
                    {{ $t('host.k_567004', { n: `"${item.award_name}"` }) }}
                  </span>
                </li>
              </ul>
            </vh-scrollbar>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import LotteryTitle from './lottery-title.vue';
  import '@/app-shared/assets/css/D-DIN-Bold/stylesheet.css';
  import { getDefaultAvatar } from '@/app-shared/utils/ossImgConfig';
  import { useLotteryServer } from 'middle-domain';
  import mallMixin from '../mixins/mall-mixin.js';

  /**
   * @description 中奖列表(发起端)
   */
  export default {
    name: 'LotteryWinner',
    mixins: [mallMixin],
    components: {
      LotteryTitle
    },
    filters: {
      fmtSerial(val) {
        const serial = `${val + 1}`;
        return serial.padStart(2, '0');
      }
    },
    data() {
      return {
        defaultAvatar: getDefaultAvatar(),
        loading: true,
        dialogVisible: false,
        total: 0,
        page: 0,
        lotteryId: '',
        winnerList: []
      };
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    },
    methods: {
      openWinList(id) {
        this.dialogVisible = true;
        this.lotteryId = id;
        this.winnerList = [];
        this.page = 1;
        this.loading = true;
        this.getWinnerList();
      },
      loadMoreData() {
        if (this.winnerList.length >= this.total) return;
        this.page++;
        this.getWinnerList();
      },
      getWinnerList() {
        const pos = (this.page - 1) * 50;
        let params = {
          limit: 50,
          pos: pos,
          need_desensitization: 0,
          lottery_id: this.lotteryId
        };
        this.lotteryServer
          .getLiveWinnerList(params)
          .then(res => {
            const list = res.data?.list || [];
            this.winnerList.push(...list);
            this.total = res.data?.total || 0;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
<style lang="less">
  .lottery-winner-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    z-index: 5;
  }
  .lottery-winner-list {
    width: 424px;
    // height: 420px;
    position: fixed;
    background: linear-gradient(180deg, #fbf0e6 0%, #fcf1e7 100%);
    border-radius: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .lottery-winner-wrapper {
      // background: #fff;
      width: 360px;
      margin: 30px auto;
      position: relative;
      // background-color: orange;

      .winner-people {
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #fff;
        margin-bottom: 2px;
        border-radius: 4px;
        color: rgba(0, 0, 0, 0.65);

        span {
          color: #fb3a32;
        }
      }
      .btn-export {
        position: absolute;
        right: 10px;
        top: 18px;
      }
    }
    .winner-content {
      background: #fff;
      overflow-y: auto;
      height: 272px;
      overflow-x: hidden;
      border-radius: 4px;
      > div,
      > ul {
        min-height: 100%;
        box-sizing: border-box;
        padding: 4px 0;
        border-radius: 4px;
      }
    }
    .lottery-winner-wrap {
      padding: 4px;
    }
    .no-winner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
      .no-win-lottery-img {
        width: 60px;
        height: 60px;
        img {
          height: 100%;
          width: 100%;
          object-fit: scale-down;
        }
      }
      .tip {
        height: 26px;
        font-weight: 500;
        font-size: 14px;
        color: #262626;
      }
    }

    .serial {
      display: inline-block;
      width: 24px;
      font-weight: 700;
      font-size: 14px;
      font-family: 'D-DIN';
    }
    .lottery-user {
      height: 44px;
      margin: 0 12px;
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      align-items: center;
      &:not(:last-child) {
        border-bottom: 1px solid rgba(#c8c8c8, 0.4);
      }
      color: #595959;
      .avatar {
        display: block;
        width: 24px;
        height: 24px;
        margin-left: 12px;
        border-radius: 50%;
        margin: 0 12px;
      }
      .nickname {
        width: 150px;
        height: 28px;
        font-size: 14px;
        line-height: 28px;
        color: #262626;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .prize {
        display: inline-block;
        width: 110px;
        text-align: right;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #262626;
        margin-left: 12px;
      }
    }
    .vmp-lottery-btn {
      margin-top: 24px;
    }
  }
</style>
